import { Route } from 'src/routes/Route'

export const CardRoute = Route({
  path: '/card/:cardId',
  init: (cardId: string) => ({ cardId }),
  fromPath: ({ cardId }) => (cardId ? { cardId } : undefined),
  hideSidebar: true,
})
export type CardRoute = Route<typeof CardRoute>
